// extracted by css-extract-rspack-plugin
module.exports =  {"description":"Description__description--_oS9j","caution":"Description__caution--PlNEJ"};